import { Injectable } from '@angular/core';
import { PaymentSuccessResponse } from 'flutterwave-angular-v3';
import { PaymentInformation } from '../_models/payments/PaymentInformation';
import { StudentRegData } from '../_models/registration/StudentRegData';

@Injectable({
  providedIn: 'root'
})
export class EnrolService {

  constructor() { }


  formatProvisionData(invoiceId:string,response: PaymentSuccessResponse,paymentData:Object, isGrouping:number, server_guardian_id:number) {

    let data = new PaymentInformation();
    data.paymentOrderId=response.tx_ref
    data.server_invoice_id=+invoiceId
    data.status=response.status||""
    data.amount=paymentData['amount']
    data.isGrouping=isGrouping
    data.server_guardian_id =server_guardian_id

    return data
  }


  formatData(formData,studentDetail:any, server_subject_id:number,subscription:any, enrol_action_name:string) {

    let studentRegDetail = new StudentRegData()

    studentRegDetail.server_student_id=studentDetail.server_student_id
    studentRegDetail.server_subject_id=server_subject_id
    studentRegDetail.server_level_id=+formData.level
    studentRegDetail.server_country_id=+formData.country
    studentRegDetail.server_user_id=studentDetail.server_user_id

    studentRegDetail.coupon=+formData.coupon
    studentRegDetail.server_enrolment_id=subscription['server_enrolment_id']
    studentRegDetail.server_subscription_id=subscription['server_subscription_id']

    studentRegDetail.is_upgrading=1
    studentDetail.enrol_action_name=enrol_action_name
    return studentRegDetail

  }
}

